import { ScrollArea } from "@timeghost/ui/shadcn/scroll-area";
import type { JSX, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface TableScrollXProps {
	readonly children: ReactNode;
	readonly className?: string;
	readonly viewportClassName?: string;
}

/** Styled horizontal ScrollArea around a min-w-max table (header + VirtualScrollList). */
export default function TableScrollX({ children, className, viewportClassName }: TableScrollXProps): JSX.Element {
	return (
		<ScrollArea
			className={cn("h-0 min-h-0 w-full min-w-0 flex-1", className)}
			viewportClassName={cn("overflow-anchor-none", viewportClassName)}>
			{children}
		</ScrollArea>
	);
}
